import { ICreditCardSummaryData } from "../common/models/credit-card.model";
import { DebitCardDetail } from "./Debit-card-details.model";
import { DepositDetail } from "./Deposit-details.model";
import { DepositOverview } from "./Deposit-Overview.model";
import { LoanDetails } from "./loan-details.model";

export interface AccountInfo {
  accountDetails?: AccountDetails[]
  loanDetails?: LoanDetails[]
  depositDetails?: DepositDetail[]
  depositOverview?: DepositOverview
  debitCardDetails?: DebitCardDetail[]
  creditCardDetails?: ICreditCardSummaryData[]

  currentAccounts?: AccountDetails[]
  savingsAccounts?: AccountDetails[]
  termDeposits?: ITermDepositDetails
  mutualFunds?: IMutualFunds
  totalLoanAmount?: string
  totalCAAmount?: string | number
  totalCASAAmount?: string | number
  totalSAAmount?: string
  totalDepositAmount?: string
  totalMutualFundAmount?: string
  loans?: ILoans
}

export interface IOverview {
  accounts: IOverviewAccountSummary[]
  total?: string
  currency?: string
}
export interface IOverviewAccountSummary {
  productType: string, 
  label: string, 
  summary: AccountDetails[] | ITermDepositProduct[] | IMutualFundsProduct[] | ILoanProduct[]
  total: string | number,
  currency: string
}

export interface IAccountSummaryData {
  accountCurrency: string
  accountName: string
  accountNumber: string
  accountStatus: string
  accountType: string
  accountTypeDesc: string
  actualBalance: string | number
  availableBalance: string | number
  nickName?:string
}

export interface AccountDetails {
  accountName: string
  actualBalance: number
  accountType: string
  accountCurrency: string
  accountNumber: string
  availableBalance: number
  address?: string
  customerCode?: string
  accountTypeDesc: string
  branchDesc?: string
  productDesc?: string
  accountStatus: string
  branchCode?: string
  closeDate?: string
  productCode?: string
  iban?: string
  openDate?: string
  routingCode?: string
  holdBalance?: string | number
  nickName?:string
}

export interface ITermDepositDetails{
  tdAmount? : string | number
  tdMaturityAmount? : string | number
  totalReturnPercentage? : string
  product: ITermDepositProduct[]
}

export interface ITermDepositProduct{
  accountDetails?: DepositDetail[]
  productCode : string
  productDesc : string
  tdAmount? : string
  tdMaturityAmount? : string
  totalReturnPercentage? : string
  totalDepositAmount?: string
  nickName?:string
}
export interface IMutualFunds {
  totalAmount: number
  product: IMutualFundsProduct[]
  totalReturnPercentage: string
  totalMaturityAmount: number
  totalUnits?: string | number
}
export interface IMutualFundsProduct {
  productDesc: string
  productCode: string
  mfMaturityAmount: string
  totalReturnPercentage: string
  accountDetails: IMutualFundsAccountDetail[]
  tdAmount?: string
  noOfUnits?:string | number
}
export interface IMutualFundsAccountDetail {
  accountName: string
  actualBalance: string
  accountType: string
  accountCurrency: string
  accountNumber: string
  accountTypeDesc: string
  openDate: string
  branch: string
  productName: string
  status: string
  availableBalance: string
  noOfUnits:string
}

export interface ILoans{
  tdAmount? : string | number
  tdMaturityAmount? : string | number
  totalReturnPercentage? : string
  totalOutstandingAmount?: string
  product: ILoanProduct[]
}

export interface ILoanProduct {
  accountDetails?: ILoanAccountDetail[]
  productCode : string
  productDesc : string
  tdAmount? : string
  tdMaturityAmount? : string
}

export interface ILoanAccountDetail{
  accountName: string
  accountNumber: string
  accountType: string
  accountTypeDesc: string
  acquiredInterest: string | number
  currency: string
  customerCode: string
  effectiveDate: string
  installmentAmount: string
  interestRate: string | number
  loanAmount: string
  maturityAmount: string
  maturityDate: string
  nextDueDtae: string
  noOfMonths: string | number
  noOfMonthsCompleted: string | number
  openDate: string
  outstandingAmount: string
  productCode: string
  productDesc: string
  nickName?: string
}
